import { makeStyles } from '@material-ui/styles'

export const useClasses = makeStyles((theme) => ({
  sync: {
    animation: '$spin 1s linear infinite',
    color: theme.palette.loading.iconColor,
    '&.material-icons': {
      fontSize: theme.typography.pxToRem(20),
    },
  },
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(360deg)',
    },
    '100%': {
      transform: 'rotate(0deg)',
    },
  },
}))
